import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import AboutContent from "./components/AboutContent";

export default function AboutPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <AboutContent />
      <Footer />
    </div>
  );
}
